import { render } from "./BodyView.vue?vue&type=template&id=43665a96&scoped=true"
import script from "./BodyView.vue?vue&type=script&lang=js"
export * from "./BodyView.vue?vue&type=script&lang=js"

import "./BodyView.vue?vue&type=style&index=0&id=43665a96&scoped=true&lang=css"
import "./BodyView.vue?vue&type=style&index=1&id=43665a96&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43665a96"]])

export default __exports__